import styles from "./styles.module.css";
import variants from "./variants.module.css";

export type buttonVariant =
  | "none"
  | "yellow"
  | "yellow-dark"
  | "red"
  | "blue"
  | "dark"
  | "glass"
  | "icon";

export default function Button({
  className = "",
  variant = "none",
  children = null,
  ...props
}: React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  variant?: buttonVariant;
}) {
  return (
    <button
      className={`${styles.root} ${variants[variant] ?? ""} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export const buttonClassName = (variant: buttonVariant = "none"): string =>
  `${styles.root} ${variants[variant] ?? ""}`;
